import React, { createContext, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "sat_lang";

const dict = {
  en: {
    // Header
    "nav.home": "Home",
    "nav.about": "About",
    "nav.services": "Facility",
    "nav.facility": "Facility",
    "nav.doctors": "Doctors",
    "nav.opd": "OPD",
    "nav.contact": "Contact",
    "cta.book": "Book Appointment",
    "cta.call": "Call Now",
    "cta.bookNow": "Reserve Visit",
    "header.tagline": "Charitable Diagnostic Centre · Krishna Nagar, New Delhi",

    // Hero
    "hero.eyebrow": "Multi-Speciality Charitable Diagnostic Centre",
    "hero.title1": "Shri Anandpur Trust",
    "hero.title2": "Healing with science.",
    "hero.title2b": "Serving with soul.",
    "hero.desc":
      "Empowering health, enriching lives — together we diagnose, heal, and build a healthier future for all. Premium MRI, CT, Dialysis, Pathology & multi-specialty OPD at nominal charitable cost.",
    "hero.stat.years": "Years of Service",
    "hero.stat.patients": "Lives Touched",
    "hero.stat.doctors": "Specialists",
    "hero.stat.services": "Diagnostic Services",

    // Trust strip
    "trust.1": "1.5 Tesla MRI",
    "trust.2": "16-Slice CT",
    "trust.3": "Free Dialysis",
    "trust.4": "Same-Day Reports",

    // Sections
    "sec.services.eyebrow": "Diagnostic Services",
    "sec.services.title1": "Premium diagnostics,",
    "sec.services.title2": "a charitable promise.",
    "sec.services.cta": "Explore all services",
    "sec.why.eyebrow": "Why Choose Us",
    "sec.why.title": "Why Choose Shri Anandpur Trust Charitable Diagnostic Centre",
    "sec.why.subtitle":
      "Built on faith, refined by science — seven decades of compassionate, technology-led healthcare for every family.",
    "sec.video.eyebrow": "Our Promise",
    "sec.video.tagline": "We believe service to mankind is service to God!",
    "sec.video.subtitle":
      "A glimpse into the everyday miracles at our charitable diagnostic centre.",
    "sec.tips.eyebrow": "Healthy Tips",
    "sec.tips.title1": "Care doesn't stop at",
    "sec.tips.title2": "our reception.",
    "sec.tips.subtitle":
      "Curated wellness videos from trusted health channels — practical tips for everyday strength, nutrition and prevention.",
    "sec.doctors.eyebrow": "Our Experts",
    "sec.doctors.title1": "30+ specialists,",
    "sec.doctors.title2": "one trusted address.",
    "sec.doctors.cta": "Meet all doctors",
    "sec.testimonials.eyebrow": "Patient Voices",
    "sec.testimonials.title1": "Stories of healing,",
    "sec.testimonials.title2": "told with gratitude.",
    "sec.emergency.eyebrow": "Need help today?",
    "sec.emergency.title": "Speak to our reception now",
    "sec.gallery.eyebrow": "Inside the Centre",
    "sec.gallery.title1": "A space designed for",
    "sec.gallery.title2": "care & calm.",
    "sec.gallery.cta": "View full gallery",
    "sec.contact.eyebrow": "Visit Us",
    "sec.contact.title1": "We're around the corner",
    "sec.contact.title2": "in Krishna Nagar.",
    "sec.contact.directions": "Get Directions",

    // Why-choose cards
    "why.nabl.t": "NABL Accredited",
    "why.nabl.d": "Our Path Lab meets the highest national quality benchmarks for diagnostic accuracy.",
    "why.tech.t": "State-of-the-Art Technology",
    "why.tech.d": "1.5 Tesla MRI, 16-Slice CT, fully automated pathology and digital radiology.",
    "why.experts.t": "Expert Medical Team",
    "why.experts.d": "30+ super-specialists, radiologists and technicians with decades of experience.",
    "why.charity.t": "Charitable, Nominal Pricing",
    "why.charity.d": "Run by a charitable trust — premium diagnostics at a fraction of private hospital costs.",
    "why.dialysis.t": "Free Dialysis Programme",
    "why.dialysis.d": "Hemodialysis offered free of cost to those in need — service to humanity in action.",
    "why.heritage.t": "70 Years of Trust",
    "why.heritage.d": "Established in 1954 by Shri Paramhans Advait Math — generations of healing.",

    // Common
    "common.address": "Address",
    "common.phone": "Phone",
    "common.email": "Email",
    "common.timings": "OPD Timings",
    "common.timings.value": "Mon – Sat · 9:00 AM – 12:00 PM",
    "common.report.note": "Report Collection: 9:00 AM – 1:00 PM & 5:30 PM – 7:00 PM",
    "common.yearsCaring": "Years caring for",
    "common.eastDelhi": "East Delhi families",

    // Tips items
    "tips.t1": "Best Chest Exercises for Strength & Tone",
    "tips.s1": "Move Your Body · Health",
    "tips.t2": "10 Minute Morning Yoga for Beginners",
    "tips.s2": "Daily Wellness",
    "tips.t3": "Heart-Healthy Foods Doctors Recommend",
    "tips.s3": "Nutrition Basics",
    "tips.t4": "Diabetes Prevention: Practical Tips",
    "tips.s4": "Preventive Care",

    // Footer
    "footer.visit": "Visit",
    "footer.servicesTitle": "Services",
    "footer.reach": "Reach Us",
    "footer.about": "About Us",
    "footer.doctors": "Our Doctors",
    "footer.opd": "OPD Schedule",
    "footer.gallery": "Gallery",
    "footer.contact": "Contact",
    "footer.book": "Book Appointment",
    "footer.newsletter": "Email for healthy tips",
    "footer.rights": "All rights reserved.",
    "footer.trustee": "",
    "footer.tagline": "Service to mankind is service to God",

    // Form
    "form.fullName": "Full name",
    "form.phone": "Phone number",
    "form.email": "Email",
    "form.emailOpt": "Email (optional)",
    "form.service": "Service",
    "form.doctor": "Preferred doctor (optional)",
    "form.date": "Preferred date",
    "form.time": "Preferred time",
    "form.notes": "Additional notes",
    "form.submit": "Confirm Request",
    "form.submitting": "Submitting…",
    "form.selectService": "Select a service",
    "form.anyDoctor": "Any available",
    "form.selectTime": "Select time slot",
    "form.subject": "Subject",
    "form.message": "Message",
    "form.send": "Send Message",
    "form.sending": "Sending…",
    "form.consent": "By submitting, you agree to be contacted at the number above.",
    "form.title": "Reserve your visit",
    "form.subtitle": "Fill in your details — our reception will confirm by phone within working hours.",
    "form.success": "Appointment Requested",
    "form.successMsg": "Thank you, {name}. Our team will call you at {phone} shortly to confirm your slot.",
    "form.ref": "Reference",
    "form.close": "Close",

    // Lang
    "lang.label": "Language",
    "lang.en": "English",
    "lang.de": "Deutsch",

    // ===== INNER PAGES (EN) =====
    "nav.book": "Book",

    // About page
    "about.eyebrow": "About the Trust",
    "about.title": "Seven decades of selfless healthcare.",
    "about.subtitle": "From a 19th-century spiritual mission to a modern NABL-accredited diagnostic centre — meet the people and ideas behind Shri Anandpur Trust.",
    "about.lineage.eyebrow": "Our Lineage",
    "about.lineage.title1": "Shri Paramhans",
    "about.lineage.title2": "Advait Math.",
    "about.lineage.p1": "Made its advent over a hundred years ago to spread the ideals of Bhakti, Karma-Yoga and spiritual knowledge. Founded by the First Great Master, the Prophet of the age, Paramhans Shri Shri 108 Shri Swami Advait Anandji Maharaj, a Sanyasi Puri born in 1846 A.D.",
    "about.lineage.p2": "The Fifth Master, Shri Shri 108 Shri Swami Darshan Puran Anandji Maharaj Ji of the Sampradaya, has accelerated the pace of promoting spiritual knowledge and selfless service.",
    "about.mission.quote": "Selfless service to mankind is the motto of this Trust. Secular in its approach, engaged in humanitarian services in education and medical aid — free treatment is imparted to the poor and needy, irrespective of caste, creed and religion.",
    "about.timeline.eyebrow": "Our Journey",
    "about.timeline.title": "A timeline of compassionate care",
    "about.timeline.1.title": "Origins",
    "about.timeline.1.text": "Founding Master Paramhans Shri Swami Advait Anandji Maharaj is born, beginning a tradition of selfless service.",
    "about.timeline.2.title": "Trust Established",
    "about.timeline.2.text": "Shri Anandpur Trust is established at Shri Anandpur near Esagarh, MP — a spiritual mission rooted in social good.",
    "about.timeline.3.title": "150-Bed Hospital",
    "about.timeline.3.text": "The Trust opens a modern hospital at Sukhpur, serving tribal and underprivileged communities of MP.",
    "about.timeline.4.title": "Delhi Centre Opens",
    "about.timeline.4.text": "High-tech charitable diagnostic centre opens in Krishna Nagar with MRI, CT, USG and Pathology — all at nominal cost.",
    "about.timeline.5.title": "Free Dialysis",
    "about.timeline.5.text": "Day-care hemodialysis facility added — extending the Trust's promise of premium care to those who cannot afford it.",
    "about.timeline.6.year": "Today",
    "about.timeline.6.title": "70 Years of Service",
    "about.timeline.6.text": "NABL-accredited, technology-led, faith-driven. The mission continues — service to mankind is service to God.",
    "about.pillars.eyebrow": "Accreditations & Pillars",
    "about.pillars.title": "Quality you can trust, care you can feel",
    "about.pillars.1.t": "NABL Accredited",
    "about.pillars.1.d": "Pathology lab certified to national standards of accuracy & safety.",
    "about.pillars.2.t": "Modern Imaging",
    "about.pillars.2.d": "1.5 Tesla MRI, 16-slice CT, digital X-Ray, ultrasound, BMD & more.",
    "about.pillars.3.t": "Specialist Care",
    "about.pillars.3.d": "Cardiology, dental, ortho, ENT, derma, gastro and more in OPD.",
    "about.pillars.4.t": "Charitable Pricing",
    "about.pillars.4.d": "All services provided at nominal cost — free dialysis included.",

    // Services hub
    "services.eyebrow": "Our Facility",
    "services.title": "Premium diagnostics, all under one roof.",
    "services.subtitle": "From MRI to dialysis, pathology to dental — accurate, accessible and charitable healthcare for every family.",
    "services.details": "Details",
    "services.book": "Book",
    "services.galleryEyebrow": "Inside the Centre",
    "services.galleryTitle": "Step into our facility",
    "services.gallerySubtitle": "Modern equipment, calm spaces and a team that treats every patient like family.",

    // Service detail
    "svc.offer.eyebrow": "What we offer",
    "svc.offer.title": "Investigations & procedures",
    "svc.prep.title": "Before your visit",
    "svc.reserve.eyebrow": "Reserve now",
    "svc.reserve.desc": "Nominal charitable pricing. NABL-grade accuracy. Same-day reports for most tests.",
    "svc.allServices": "All services",
    "svc.related": "Related services",

    // Doctors
    "doctors.eyebrow": "Meet Our Experts",
    "doctors.title": "Doctors who lead with skill — and heart.",
    "doctors.subtitle": "Our panel of 30+ super-specialists, radiologists and therapists practising under one charitable roof.",
    "doctors.empty": "No doctors found.",

    // OPD
    "opd.eyebrow": "Outpatient Department",
    "opd.title": "OPD schedule & specialty clinics.",
    "opd.subtitle": "Multi-speciality consultations open six days a week — book your slot ahead of time to avoid the wait.",
    "opd.weekly": "Weekly OPD Timings",
    "opd.reportCollection": "Report Collection",
    "opd.monSat": "Monday – Saturday",
    "opd.specialtyClinics.eyebrow": "Specialty Clinics",
    "opd.specialtyClinics.title": "Choose your specialty",
    "opd.doctorCount": "{n} doctor",
    "opd.doctorCountPlural": "{n} doctors",
    "opd.bookOpd": "Book OPD",
    "opd.day.Monday": "Monday",
    "opd.day.Tuesday": "Tuesday",
    "opd.day.Wednesday": "Wednesday",
    "opd.day.Thursday": "Thursday",
    "opd.day.Friday": "Friday",
    "opd.day.Saturday": "Saturday",
    "opd.day.Sunday": "Sunday",
    "opd.closed": "Closed",
    "opd.report.morning": "Morning Collection",
    "opd.report.evening": "Evening Collection",

    // Gallery
    "gallery.eyebrow": "Gallery",
    "gallery.title": "A look inside our centre.",
    "gallery.subtitle": "Modern technology paired with calm, dignified spaces — see the care environment we've built for you.",

    // Contact
    "contact.eyebrow": "Get in Touch",
    "contact.title": "We'd love to hear from you.",
    "contact.subtitle": "Questions, feedback, or scheduling a visit — our team responds within working hours.",
    "contact.reach.eyebrow": "Reach the centre",
    "contact.reach.title1": "Krishna Nagar,",
    "contact.reach.title2": "New Delhi.",
    "contact.formTitle": "Send us a message",
    "contact.formSubtitle": "We typically respond within 1 business day.",
    "contact.success": "Thanks! Your message has been received.",

    // Book page (now phone dial)
    "book.eyebrow": "Appointments",
    "book.title": "Call our reception to book your visit.",
    "book.subtitle": "Our team will note down your details and confirm your slot on the call.",
    "book.callTitle": "Tap to call our centre",
    "book.callDesc": "Speaking with our reception is the fastest way to book — we'll suggest the best slot for your service and doctor.",
    "book.hint": "Outside hours? WhatsApp us and we'll get back the next morning.",
  },
  de: {
    // Header
    "nav.home": "Startseite",
    "nav.about": "Über uns",
    "nav.services": "Einrichtung",
    "nav.facility": "Einrichtung",
    "nav.doctors": "Ärzte",
    "nav.opd": "Sprechstunde",
    "nav.contact": "Kontakt",
    "cta.book": "Termin buchen",
    "cta.call": "Jetzt anrufen",
    "cta.bookNow": "Besuch reservieren",
    "header.tagline": "Gemeinnütziges Diagnosezentrum · Krishna Nagar, Neu-Delhi",

    // Hero
    "hero.eyebrow": "Gemeinnütziges Mehrfach-Fachdiagnosezentrum",
    "hero.title1": "Shri Anandpur Trust",
    "hero.title2": "Heilen mit Wissenschaft.",
    "hero.title2b": "Dienen mit Herz.",
    "hero.desc":
      "Gesundheit stärken, Leben bereichern — wir diagnostizieren, heilen und gestalten gemeinsam eine gesündere Zukunft. Hochwertige MRT, CT, Dialyse, Pathologie und fachärztliche Sprechstunde zu einem geringen Beitrag.",
    "hero.stat.years": "Jahre im Dienst",
    "hero.stat.patients": "Berührte Leben",
    "hero.stat.doctors": "Fachärzte",
    "hero.stat.services": "Diagnostische Leistungen",

    // Trust
    "trust.1": "1,5 Tesla MRT",
    "trust.2": "16-Schicht-CT",
    "trust.3": "Kostenlose Dialyse",
    "trust.4": "Befunde am selben Tag",

    // Sections
    "sec.services.eyebrow": "Diagnostische Leistungen",
    "sec.services.title1": "Premium-Diagnostik,",
    "sec.services.title2": "ein wohltätiges Versprechen.",
    "sec.services.cta": "Alle Leistungen ansehen",
    "sec.why.eyebrow": "Warum wir",
    "sec.why.title": "Warum Shri Anandpur Trust Charitable Diagnostic Centre wählen",
    "sec.why.subtitle":
      "Auf Vertrauen gebaut, durch Wissenschaft verfeinert — sieben Jahrzehnte mitfühlende, technologiegestützte Gesundheitsversorgung für jede Familie.",
    "sec.video.eyebrow": "Unser Versprechen",
    "sec.video.tagline": "Wir glauben: Dienst am Menschen ist Dienst an Gott!",
    "sec.video.subtitle":
      "Ein Einblick in die alltäglichen Wunder in unserem gemeinnützigen Diagnosezentrum.",
    "sec.tips.eyebrow": "Gesundheitstipps",
    "sec.tips.title1": "Fürsorge endet nicht an",
    "sec.tips.title2": "unserer Rezeption.",
    "sec.tips.subtitle":
      "Ausgewählte Wellness-Videos von vertrauenswürdigen Gesundheitskanälen — praktische Tipps für Kraft, Ernährung und Vorsorge.",
    "sec.doctors.eyebrow": "Unsere Experten",
    "sec.doctors.title1": "Über 30 Fachärzte,",
    "sec.doctors.title2": "eine vertraute Adresse.",
    "sec.doctors.cta": "Alle Ärzte ansehen",
    "sec.testimonials.eyebrow": "Patientenstimmen",
    "sec.testimonials.title1": "Geschichten der Heilung,",
    "sec.testimonials.title2": "voller Dankbarkeit erzählt.",
    "sec.emergency.eyebrow": "Brauchen Sie heute Hilfe?",
    "sec.emergency.title": "Sprechen Sie jetzt mit unserer Rezeption",
    "sec.gallery.eyebrow": "Im Zentrum",
    "sec.gallery.title1": "Ein Ort, geschaffen für",
    "sec.gallery.title2": "Fürsorge & Ruhe.",
    "sec.gallery.cta": "Gesamte Galerie ansehen",
    "sec.contact.eyebrow": "Besuchen Sie uns",
    "sec.contact.title1": "Wir sind um die Ecke",
    "sec.contact.title2": "in Krishna Nagar.",
    "sec.contact.directions": "Wegbeschreibung",

    // Why-choose cards
    "why.nabl.t": "NABL-akkreditiert",
    "why.nabl.d": "Unser Pathologielabor erfüllt höchste nationale Qualitätsstandards.",
    "why.tech.t": "Modernste Technologie",
    "why.tech.d": "1,5 Tesla MRT, 16-Schicht-CT, vollautomatisierte Pathologie und digitale Radiologie.",
    "why.experts.t": "Erfahrenes Ärzteteam",
    "why.experts.d": "Über 30 Fachärzte, Radiologen und Techniker mit jahrzehntelanger Erfahrung.",
    "why.charity.t": "Wohltätige, geringe Kosten",
    "why.charity.d": "Geführt von einer gemeinnützigen Stiftung — Premium-Diagnostik zu einem Bruchteil der Privatklinik-Kosten.",
    "why.dialysis.t": "Kostenlose Dialyse",
    "why.dialysis.d": "Hämodialyse wird Bedürftigen kostenfrei angeboten — Menschlichkeit in Aktion.",
    "why.heritage.t": "70 Jahre Vertrauen",
    "why.heritage.d": "Gegründet 1954 von Shri Paramhans Advait Math — Generationen der Heilung.",

    // Common
    "common.address": "Adresse",
    "common.phone": "Telefon",
    "common.email": "E-Mail",
    "common.timings": "Sprechzeiten",
    "common.timings.value": "Mo – Sa · 9:00 – 12:00 Uhr",
    "common.report.note": "Befundausgabe: 9:00 – 13:00 Uhr & 17:30 – 19:00 Uhr",
    "common.yearsCaring": "Jahre Fürsorge für",
    "common.eastDelhi": "Familien in Ost-Delhi",

    // Tips
    "tips.t1": "Beste Brustübungen für Kraft & Tonus",
    "tips.s1": "Bewege dich · Gesundheit",
    "tips.t2": "10 Minuten Morgenyoga für Anfänger",
    "tips.s2": "Tägliches Wohlbefinden",
    "tips.t3": "Herzgesunde Lebensmittel",
    "tips.s3": "Ernährungs-Grundlagen",
    "tips.t4": "Diabetes-Prävention: Praktische Tipps",
    "tips.s4": "Vorsorge",

    // Footer
    "footer.visit": "Besuchen",
    "footer.servicesTitle": "Leistungen",
    "footer.reach": "Kontaktieren",
    "footer.about": "Über uns",
    "footer.doctors": "Unsere Ärzte",
    "footer.opd": "Sprechplan",
    "footer.gallery": "Galerie",
    "footer.contact": "Kontakt",
    "footer.book": "Termin buchen",
    "footer.newsletter": "E-Mail für Gesundheitstipps",
    "footer.rights": "Alle Rechte vorbehalten.",
    "footer.trustee": "Geschäftsführender Treuhänder",
    "footer.tagline": "Dienst am Menschen ist Dienst an Gott",

    // Form
    "form.fullName": "Vollständiger Name",
    "form.phone": "Telefonnummer",
    "form.email": "E-Mail",
    "form.emailOpt": "E-Mail (optional)",
    "form.service": "Leistung",
    "form.doctor": "Bevorzugter Arzt (optional)",
    "form.date": "Wunschtermin",
    "form.time": "Bevorzugte Zeit",
    "form.notes": "Zusätzliche Hinweise",
    "form.submit": "Anfrage bestätigen",
    "form.submitting": "Wird gesendet…",
    "form.selectService": "Leistung wählen",
    "form.anyDoctor": "Jeder verfügbar",
    "form.selectTime": "Zeitfenster wählen",
    "form.subject": "Betreff",
    "form.message": "Nachricht",
    "form.send": "Nachricht senden",
    "form.sending": "Wird gesendet…",
    "form.consent": "Mit dem Absenden stimmen Sie zu, unter obiger Nummer kontaktiert zu werden.",
    "form.title": "Reservieren Sie Ihren Besuch",
    "form.subtitle": "Geben Sie Ihre Daten ein — unsere Rezeption bestätigt telefonisch zu den Geschäftszeiten.",
    "form.success": "Termin angefragt",
    "form.successMsg": "Danke, {name}. Unser Team ruft Sie unter {phone} an, um den Termin zu bestätigen.",
    "form.ref": "Referenz",
    "form.close": "Schließen",

    // Lang
    "lang.label": "Sprache",
    "lang.en": "English",
    "lang.de": "Deutsch",

    // ===== INNER PAGES (DE) =====
    "nav.book": "Buchen",

    // About page
    "about.eyebrow": "Über die Stiftung",
    "about.title": "Sieben Jahrzehnte selbstloser Gesundheitsversorgung.",
    "about.subtitle": "Von einer spirituellen Mission des 19. Jahrhunderts bis zum modernen, NABL-akkreditierten Diagnosezentrum — lernen Sie die Menschen und Ideen hinter Shri Anandpur Trust kennen.",
    "about.lineage.eyebrow": "Unsere Linie",
    "about.lineage.title1": "Shri Paramhans",
    "about.lineage.title2": "Advait Math.",
    "about.lineage.p1": "Seit über hundert Jahren widmet sich diese Mission der Verbreitung von Bhakti, Karma-Yoga und spirituellem Wissen. Gegründet vom ersten Großmeister, dem Propheten der Zeit, Paramhans Shri Shri 108 Shri Swami Advait Anandji Maharaj, ein 1846 n. Chr. geborener Sanyasi Puri.",
    "about.lineage.p2": "Der fünfte Meister, Shri Shri 108 Shri Swami Darshan Puran Anandji Maharaj Ji der Sampradaya, treibt die Verbreitung spirituellen Wissens und selbstlosen Dienstes voran.",
    "about.mission.quote": "Selbstloser Dienst am Menschen ist das Motto dieser Stiftung. Säkular ausgerichtet, engagiert in humanitären Diensten in Bildung und medizinischer Hilfe — Bedürftige erhalten kostenlose Behandlung, unabhängig von Kaste, Glauben und Religion.",
    "about.timeline.eyebrow": "Unser Weg",
    "about.timeline.title": "Eine Chronik mitfühlender Fürsorge",
    "about.timeline.1.title": "Ursprünge",
    "about.timeline.1.text": "Geburt des Gründungs-Meisters Paramhans Shri Swami Advait Anandji Maharaj — der Beginn einer Tradition des selbstlosen Dienstes.",
    "about.timeline.2.title": "Gründung der Stiftung",
    "about.timeline.2.text": "Shri Anandpur Trust wird bei Esagarh in Madhya Pradesh gegründet — eine spirituelle Mission mit sozialem Auftrag.",
    "about.timeline.3.title": "150-Betten-Krankenhaus",
    "about.timeline.3.text": "Die Stiftung eröffnet ein modernes Krankenhaus in Sukhpur und versorgt indigene und benachteiligte Gemeinschaften.",
    "about.timeline.4.title": "Eröffnung Delhi-Zentrum",
    "about.timeline.4.text": "Hochmodernes gemeinnütziges Diagnosezentrum in Krishna Nagar mit MRT, CT, Ultraschall und Pathologie — zu geringen Kosten.",
    "about.timeline.5.title": "Kostenlose Dialyse",
    "about.timeline.5.text": "Tages-Dialyseeinheit ergänzt — Premium-Versorgung auch für jene, die sie sich nicht leisten können.",
    "about.timeline.6.year": "Heute",
    "about.timeline.6.title": "70 Jahre im Dienst",
    "about.timeline.6.text": "NABL-akkreditiert, technologiegetrieben, glaubensgeleitet. Die Mission lebt weiter — Dienst am Menschen ist Dienst an Gott.",
    "about.pillars.eyebrow": "Akkreditierungen & Säulen",
    "about.pillars.title": "Qualität, der Sie vertrauen können — Fürsorge, die Sie spüren",
    "about.pillars.1.t": "NABL-akkreditiert",
    "about.pillars.1.d": "Pathologielabor zertifiziert nach nationalen Standards für Genauigkeit & Sicherheit.",
    "about.pillars.2.t": "Moderne Bildgebung",
    "about.pillars.2.d": "1,5 Tesla MRT, 16-Schicht-CT, digitales Röntgen, Ultraschall, BMD u.v.m.",
    "about.pillars.3.t": "Fachärztliche Versorgung",
    "about.pillars.3.d": "Kardiologie, Zahnheilkunde, Orthopädie, HNO, Dermatologie, Gastroenterologie u.a. in der Sprechstunde.",
    "about.pillars.4.t": "Wohltätige Preise",
    "about.pillars.4.d": "Alle Leistungen zu geringen Kosten — kostenlose Dialyse inklusive.",

    // Services hub
    "services.eyebrow": "Unsere Einrichtung",
    "services.title": "Premium-Diagnostik, alles unter einem Dach.",
    "services.subtitle": "Von MRT bis Dialyse, Pathologie bis Zahnmedizin — genaue, zugängliche und wohltätige Versorgung für jede Familie.",
    "services.details": "Details",
    "services.book": "Buchen",
    "services.galleryEyebrow": "Im Zentrum",
    "services.galleryTitle": "Treten Sie in unsere Einrichtung",
    "services.gallerySubtitle": "Moderne Geräte, ruhige Räume und ein Team, das jeden Patienten wie Familie behandelt.",

    // Service detail
    "svc.offer.eyebrow": "Unser Angebot",
    "svc.offer.title": "Untersuchungen & Behandlungen",
    "svc.prep.title": "Vor Ihrem Besuch",
    "svc.reserve.eyebrow": "Jetzt reservieren",
    "svc.reserve.desc": "Geringe wohltätige Preise. NABL-Qualität. Befunde für die meisten Tests am selben Tag.",
    "svc.allServices": "Alle Leistungen",
    "svc.related": "Verwandte Leistungen",

    // Doctors
    "doctors.eyebrow": "Lernen Sie unsere Experten kennen",
    "doctors.title": "Ärzte mit Können — und Herz.",
    "doctors.subtitle": "Unser Team aus über 30 Fachärzten, Radiologen und Therapeuten unter einem wohltätigen Dach.",
    "doctors.empty": "Keine Ärzte gefunden.",

    // OPD
    "opd.eyebrow": "Ambulanz",
    "opd.title": "Sprechplan & Fachambulanzen.",
    "opd.subtitle": "Fachärztliche Sprechstunden an sechs Tagen die Woche — reservieren Sie vorab, um Wartezeit zu vermeiden.",
    "opd.weekly": "Wöchentliche Sprechzeiten",
    "opd.reportCollection": "Befundausgabe",
    "opd.monSat": "Montag – Samstag",
    "opd.specialtyClinics.eyebrow": "Fachambulanzen",
    "opd.specialtyClinics.title": "Wählen Sie Ihre Fachrichtung",
    "opd.doctorCount": "{n} Arzt",
    "opd.doctorCountPlural": "{n} Ärzte",
    "opd.bookOpd": "Sprechstunde buchen",
    "opd.day.Monday": "Montag",
    "opd.day.Tuesday": "Dienstag",
    "opd.day.Wednesday": "Mittwoch",
    "opd.day.Thursday": "Donnerstag",
    "opd.day.Friday": "Freitag",
    "opd.day.Saturday": "Samstag",
    "opd.day.Sunday": "Sonntag",
    "opd.closed": "Geschlossen",
    "opd.report.morning": "Vormittags-Ausgabe",
    "opd.report.evening": "Abend-Ausgabe",

    // Gallery
    "gallery.eyebrow": "Galerie",
    "gallery.title": "Ein Blick in unser Zentrum.",
    "gallery.subtitle": "Moderne Technologie und ruhige, würdevolle Räume — sehen Sie das Umfeld, das wir für Sie geschaffen haben.",

    // Contact
    "contact.eyebrow": "Kontakt aufnehmen",
    "contact.title": "Wir freuen uns auf Ihre Nachricht.",
    "contact.subtitle": "Fragen, Rückmeldungen oder Terminwunsch — unser Team antwortet während der Geschäftszeiten.",
    "contact.reach.eyebrow": "Erreichen Sie uns",
    "contact.reach.title1": "Krishna Nagar,",
    "contact.reach.title2": "Neu-Delhi.",
    "contact.formTitle": "Nachricht senden",
    "contact.formSubtitle": "Wir antworten in der Regel innerhalb eines Werktages.",
    "contact.success": "Danke! Ihre Nachricht ist eingegangen.",

    // Book
    "book.eyebrow": "Termine",
    "book.title": "Rufen Sie unsere Rezeption an, um Ihren Termin zu buchen.",
    "book.subtitle": "Unser Team nimmt Ihre Daten auf und bestätigt den Termin im Telefonat.",
    "book.callTitle": "Tippen, um unser Zentrum anzurufen",
    "book.callDesc": "Ein Anruf bei unserer Rezeption ist der schnellste Weg zur Buchung — wir schlagen Ihnen die beste Zeit für Ihre Leistung und Ihren Arzt vor.",
    "book.hint": "Außerhalb der Zeiten? Schreiben Sie uns per WhatsApp, wir melden uns am nächsten Morgen.",
  },
};

const LangContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    return window.localStorage.getItem(STORAGE_KEY) || "en";
  });

  const setLang = (l) => {
    setLangState(l);
    try { window.localStorage.setItem(STORAGE_KEY, l); } catch (_) {}
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key, vars) => {
    let s = (dict[lang] && dict[lang][key]) || dict.en[key] || key;
    if (vars) {
      for (const k of Object.keys(vars)) s = s.replaceAll(`{${k}}`, vars[k]);
    }
    return s;
  };

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
